import { GetServerSideProps } from "next";
import { serverSideTranslations } from "../../common/utility/serverSideTranslations";
import { getSelectorsByUserAgent } from "react-device-detect";
import { SingleQuestionPage } from "../../domains/qi/pages/questionPage/singleQuestionPage";
import { convertLangToXLocale } from "../../domains/qi/services/utiltyService";
import type { IKunduzRequest } from "../../common/interfaces";
import { initalizeMiddlewares } from "../../common/middlewares";
import { saveContentLangToCookie } from "../../common/services/utilityService";
import { getCachedHeaderItems } from "../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../common/services/cachedHeaderBanner";

export default function Index(props) {
  return <SingleQuestionPage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  req,
  res,
  locale,
  query,
}) => {
  await initalizeMiddlewares(req, res, "");
  const { kz_user_token } = req.cookies;
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const lang = "tr";

  if (!query.questionSlug || !lang) {
    return {
      notFound: true,
    };
  }
  const slug = query.questionSlug as string;
  const xLocale = convertLangToXLocale(lang);
  saveContentLangToCookie(lang, { res });

  let id;
  // try get id
  try {
    id = (slug as string).match(/-(\d+)$/)[1];
  } catch (error) {
    return {
      notFound: true,
    };
  }

  let question;
  try {
    question = await (
      req as IKunduzRequest
    ).elasticClient.getSingleQuestionById(xLocale, id);
  } catch (error) {
    return {
      notFound: true,
    };
  }
  const headerItems = await getCachedHeaderItems(lang, "student");
  const headerBanner = await getCachedHeaderBanner(lang);

  /**
   * LISTED = 1,
  REMOVED = 2,
  UNLISTED = 3,
   */
  if (!question || question.status == 2) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      question,
      isMobile,
      isAuth: !!kz_user_token,
      lang,
      query,
      headerItems,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_common",
      ])),
    },
  };
};
